<router-outlet *ngIf="isOnline">
</router-outlet>
<!-- <ngx-spinner *ngIf="!isOnline"></ngx-spinner> -->
<!-- <fa-custom-offline *ngIf="!isOnline">
</fa-custom-offline> -->